import moment from 'moment'

export default function getDuration(start, end) {
  if (moment.unix(start).isDST() && !moment.unix(end).isDST()) {
    // console.log('start is DST, end is not, removing 1h')
    end -= 3600
  }
  return (end - start) / 3600
}
